// Filtrare proiecte/regii active într-o zi dată — folosită în dropdown-urile de logare ore.
const PIPELINE_CATS = ["1", "1.2", "2", "3", "4"];
const DONE_CATS = ["7", "8", "9", "10"];

export const projectActiveOnDay = (p, iso) => {
  const cat = String(p.category || "");
  if (PIPELINE_CATS.includes(cat) || DONE_CATS.includes(cat)) return false;
  if (cat === "6.1") return true; // finalizat – de demontat
  const sd = p.start_date || "";
  const ed = p.end_date || sd;
  if (sd && iso < sd) return false;
  if (ed) {
    const d = new Date(ed + "T00:00:00");
    d.setDate(d.getDate() + 1); // +1 zi pentru demontaj
    if (iso > d.toISOString().slice(0, 10)) return false;
  }
  return true;
};

export const regieActiveOnDay = (r, iso) => {
  if (r.active === false) return false;
  const sd = r.start_date || "";
  const ed = r.indeterminate_end ? "9999-12-31" : (r.end_date || sd);
  if (sd && iso < sd) return false;
  if (ed && iso > ed) return false;
  for (const p of (r.pauses || [])) {
    if ((p.start_date || "") <= iso && iso <= (p.end_date || "9999-12-31")) return false;
  }
  return true;
};
